import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, TrendingUp, DollarSign, Activity } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface DashboardStatsProps {
  totalUsers: number;
  usersByRole: {
    free: number;
    student: number;
    paid: number;
    admin: number;
  };
  totalVisits: number;
  expectedMonthlyIncome: number;
  totalSuperCalcQueries: number;
  totalSuperCalcCost: number;
}

export function DashboardStats({
  totalUsers,
  usersByRole,
  totalVisits,
  expectedMonthlyIncome,
  totalSuperCalcQueries,
  totalSuperCalcCost,
}: DashboardStatsProps) {
  const navigate = useNavigate();
  
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Total Users</CardTitle>
          <Users className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{totalUsers}</div>
          <div className="text-xs text-muted-foreground mt-2">
            <div>Free: {usersByRole.free}</div>
            <div>Student: {usersByRole.student}</div>
            <div>Paid: {usersByRole.paid}</div>
            <div>Admin: {usersByRole.admin}</div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Expected Monthly Income</CardTitle>
          <DollarSign className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">${expectedMonthlyIncome.toFixed(2)}</div>
          <p className="text-xs text-muted-foreground mt-2">
            Based on membership tiers
          </p>
        </CardContent>
      </Card>

      <Card 
        className="cursor-pointer hover:bg-accent/50 transition-colors"
        onClick={() => navigate('/analytics')}
      >
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Website Visits</CardTitle>
          <Activity className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{totalVisits.toLocaleString()}</div>
          <p className="text-xs text-muted-foreground mt-2">
            Click to view detailed analytics
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">SuperCalc Usage</CardTitle>
          <TrendingUp className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{totalSuperCalcQueries}</div>
          <p className="text-xs text-muted-foreground mt-2">
            Total cost: ${totalSuperCalcCost.toFixed(4)}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
